module.exports = __webpack_public_path__ + "static/contact.loc-3889806437cee01e331d326de5122621.jpg";